/**
 * Message priority constants
 * Defines priority levels and their corresponding numeric values for API calls
 */
export const MESSAGE_PRIORITY = {
  LOW: 'Low',
  NORMAL: 'Normal',
  HIGH: 'High',
  URGENT: 'Urgent',
} as const;

export type MessagePriority = typeof MESSAGE_PRIORITY[keyof typeof MESSAGE_PRIORITY];

/**
 * Mapping of priority labels to numeric values used by the API
 */
export const MESSAGE_PRIORITY_VALUE = {
  [MESSAGE_PRIORITY.LOW]: 1,
  [MESSAGE_PRIORITY.NORMAL]: 2,
  [MESSAGE_PRIORITY.HIGH]: 3,
  [MESSAGE_PRIORITY.URGENT]: 4,
} as const;

/**
 * Default priority for new messages
 */
export const DEFAULT_MESSAGE_PRIORITY = MESSAGE_PRIORITY.NORMAL;
export const DEFAULT_MESSAGE_PRIORITY_VALUE = MESSAGE_PRIORITY_VALUE[DEFAULT_MESSAGE_PRIORITY];
